import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { type InstallationInfo } from 'generated-sources';

const STORAGE_KEY = 'kb-current-installation';

const currentInstallationAtom = atomWithStorage<InstallationInfo | undefined>(
  STORAGE_KEY,
  undefined,
);

export const useCurrentInstallation = () => {
  return useAtom(currentInstallationAtom);
};

/**
 * Clear the persisted installation outside of React (e.g. from global error handlers).
 * The Jotai atom will pick up the change on next render via storage event.
 */
export const clearCurrentInstallation = () => {
  localStorage.removeItem(STORAGE_KEY);
};
